module.exports = __webpack_public_path__ + "img/FW_Angelsword.c135d58e.png";